module.exports = "<select\n    ng-if=\"CategoryFilterCtrl.categories.length\"\n    ng-model=\"CategoryFilterCtrl.category\"\n    ng-options=\"item.id as item.name for item in CategoryFilterCtrl.categories\"\n>\n    <option value=\"\">Kategoria</option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/filters/category-filter/category-filter.html
// module id = 620
// module chunks = 0